import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { cn } from "@omni/utils/styles";
import { ReactElement } from "react";

import Stock from "@/components/Store/StoreDetails/stock.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    productAvailability?: CloudProductAvailability;
    shopName?: string;
};

const ItemStock = ({ productAvailability, shopName }: Props): ReactElement => {
    const { t } = useGranite();
    return (
        <div
            className={cn("tw:mb-2")}
            style={{
                opacity:
                    productAvailability?.stockLevel ===
                        CloudStockLevel.NoStock ||
                    productAvailability?.stockLevel ===
                        CloudStockLevel.UnknownStock
                        ? "0.5"
                        : "1"
            }}
        >
            {shopName && (
                <div className={cn("tw:text-sm tw:font-bold")}>
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            <div className={cn("tw:text-sm")}>
                <Stock productAvailability={productAvailability} />
            </div>
        </div>
    );
};

export { ItemStock };
